import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL, TOKEN, URL } from "./Constants";

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: async (headers) => {
      const token = localStorage.getItem("token");
      headers.set("Authorization", "Bearer " + token);
      // headers.set("Content-Type", "multipart/form-data");
      // headers.set("Content-Type", "application/json");
      headers.set("Accept", "application/json");
    },
  }),
  refetchOnMountOrArgChange: true,
  tagTypes: [],
  endpoints: (builder) => ({
    // LOGIN
    login: builder.mutation({
      query: (payload) => ({
        url: URL.LOGIN,
        body: payload,
        method: "POST",
      }),
    }),

    // LOGOUT
    logout: builder.query({
      query: () => URL.LOGOUT,
    }),

    //  admin list
    adminList: builder.mutation({
      query: (payload) => ({
        url: URL.ADMIN,
        body: payload,
        method: "POST",
      }),
    }),
    //  admin status
    adminListStatus: builder.query({
      query: (id) => URL.ADMINSTATUS + id,
    }),
    //  admin View
    adminListView: builder.query({
      query: (id) => URL.ADMINVIEW + id,
    }),
    // Admin Delete
    adminDelete: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.ADMINDELETE + id,
        body: payload,
        method: "DELETE",
      }),
    }),
    // Admin Edit
    adminEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.ADMINEDIT + id + "/update",
        body: payload,
        method: "POST",
      }),
    }),

    // role list
    adminListRole: builder.query({
      query: () => URL.ADMINROLE,
    }),
    // Admin ADD
    adminAdd: builder.mutation({
      query: (payload) => ({
        url: URL.ADMINADD,
        body: payload,
        method: "POST",
      }),
    }),
    // Minimum age list
    minimumAge: builder.mutation({
      query: (payload) => ({
        url: URL.AGESLIST,
        body: payload,
        method: "POST",
      }),
    }),

    // Minimum age list
    minimumAgeView: builder.query({
      query: (id) => URL.AGESVIEW + id,
    }),
    //  Minimum age Edit
    minimumAgeEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.AGESEDIT + id + "/update",
        body: payload,
        method: "POST",
      }),
    }),
    //  Minimum age Add
    minimumAgeAdd: builder.mutation({
      query: (payload) => ({
        url: URL.AGESADD,
        body: payload,
        method: "POST",
      }),
    }),
    //  Minimum age Status
    minimumAgeStatus: builder.mutation({
      query: (id) => ({
        url: URL.AGESSTATUS + id + "/status",
        method: "POST",
      }),
    }),

    // property-contents
    propertyContents: builder.query({
      query: () => URL.PROPERTYCONTENT,
    }),
    // property-contents view
    propertyContentsView: builder.query({
      query: (id) => URL.PROPERTYCONTENTVIEW + id,
    }),

    // property-contents Update
    propertyContentsUpdate: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTYCONTENTUPDATE,
        body: payload,
        method: "POST",
      }),
    }),

    // banner list
    bannerList: builder.mutation({
      query: (payload) => ({
        url: URL.BANNERLIST,
        body: payload,
        method: "POST",
      }),
    }),
    // Room category list
    roomList: builder.mutation({
      query: (payload) => ({
        url: URL.ROOMLIST,
        body: payload,
        method: "POST",
      }),
    }),

    // Room category View
    roomView: builder.query({
      query: (id) => URL.ROOMVIEW + id,
    }),

    //  Room category list Status
    roomListStatus: builder.mutation({
      query: (id) => ({
        url: URL.ROOMSTATUS + id + "/status",
        method: "POST",
      }),
    }),
    //  Room category list Update
    roomListUpdate: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.ROOMEDIT + id + "/update",
        body: payload,
        method: "POST",
      }),
    }),
    //  Room category list Add
    roomListAdd: builder.mutation({
      query: (payload) => ({
        url: URL.ROOMADD,
        body: payload,
        method: "POST",
      }),
    }),
    // Amenities list
    amenitiesPostList: builder.mutation({
      query: (payload) => ({
        url: URL.AMENITIESLIST,
        body: payload,
        method: "POST",
      }),
    }),

    amenitiesList: builder.query({
      query: () => ({
        url: URL.AMENITIESLIST,
        method: "GET",
      }),
    }),

    //  Amenities list Status
    amenitiesListStatus: builder.mutation({
      query: (id) => ({
        url: URL.AMENITIESSTATUS + id + "/status",
        method: "POST",
      }),
    }),

    //  Amenities Dropdown
    amenitiesDrop: builder.query({
      query: () => URL.AMENITIESDROP,
    }),
    //  Roomcategories Dropdown
    roomCategoriesDrop: builder.query({
      query: () => URL.ROOMDROP,
    }),

    //  Amenities list Update
    amenitiesListUpdate: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.AMENITIESEDIT + id + "/update",
        body: payload,
        method: "POST",
      }),
    }),
    //  Amenities list Add
    amenitiesListAdd: builder.mutation({
      query: (payload) => ({
        url: URL.AMENITIESADD,
        body: payload,
        method: "POST",
      }),
    }),

    newTotalLocationsList: builder.mutation({
      query: (payload) => ({
        url: URL.TOTAL_LOACATIONS,
        body: payload,
        method: "POST",
      }),
    }),

    // banner Delete
    bannerDelete: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.BANNERDELETE + id,
        body: payload,
        method: "DELETE",
      }),
    }),
    // banner view
    bannerView: builder.query({
      query: (id) => URL.BANNERVIEW + id,
    }),
    // ammenities view
    amenitiesView: builder.query({
      query: (id) => URL.AMENITIESVIEW + id,
    }),
    // property amenities list
    propertyAmenitiesList: builder.query({
      query: () => URL.PROPERTY_AMENITIES_LIST,
    }),
    //  banner list Add
    bannerListAdd: builder.mutation({
      query: (payload) => ({
        url: URL.BANNERADD,
        body: payload,
        method: "POST",
      }),
    }),
    //  banner edit
    bannerListEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.BANNEREDIT + id + "/update",
        body: payload,
        method: "POST",
      }),
    }),
    // BANNER location view
    bannerLocationView: builder.mutation({
      query: (payload) => ({
        url: URL.BANNERLOCATION,
        body: payload,
        method: "POST",
      }),
    }),
    // users List
    usersList: builder.mutation({
      query: (payload) => ({
        url: URL.USERLIST,
        body: payload,
        method: "POST",
      }),
    }),

    // users List View
    usersListView: builder.query({
      query: (id) => URL.USERLISTVIEW + id,
    }),
    // users Status
    usersListStatus: builder.query({
      query: (id) => URL.USERSTATUS + id + "/status",
    }),
    // users List Edit
    userListEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.USERLISTEDIT + id + "/update",
        body: payload,
        method: "POST",
      }),
    }),
    // owners List
    ownersList: builder.mutation({
      query: (payload) => ({
        url: URL.OWNERSLIST,
        body: payload,
        method: "POST",
      }),
    }),
    // owners List Get
    ownersListGet: builder.query({
      query: () => URL.OWNERSGET,
    }),
    // owners drop List Get
    ownersDropList: builder.query({
      query: () => URL.OWNERSDROPLIST,
    }),

    // owners List Edit
    ownersListEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.OWNERSLISTEDIT + id,
        body: payload,
        method: "POST",
      }),
    }),
    // owners List View
    ownersListView: builder.query({
      query: (id) => URL.OWNERSLISTVIEW + id,
    }),
    // owners List Add
    ownersListAdd: builder.mutation({
      query: (payload) => ({
        url: URL.OWNERSLISTADD,
        body: payload,
        method: "POST",
      }),
    }),
    // reception List
    receptionList: builder.mutation({
      query: (payload) => ({
        url: URL.RECEPTIONLIST,
        body: payload,
        method: "POST",
      }),
    }),

    receptionListGet: builder.query({
      query: () => URL.RECEPTIONGET,
    }),
    // reception List View
    receptionListView: builder.query({
      query: (id) => URL.RECEPTIONVIEW + id,
    }),
    //owner Status
    ownerStatus: builder.query({
      query: (id) => URL.OWNERSTATUS + id + "/status",
    }),
    // owners List Add
    receptionListAdd: builder.mutation({
      query: (payload) => ({
        url: URL.RECEPTIONADD,
        body: payload,
        method: "POST",
      }),
    }),
    // owners List Edit
    receptionListEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.RECEPTIONEDIT + id + "/update",
        body: payload,
        method: "POST",
      }),
    }),
    // owners List Edit
    receptionStatus: builder.mutation({
      query: (payload) => ({
        url: URL.RECEPTIONSTATUS,
        body: payload,
        method: "POST",
      }),
    }),

    //Properties add
    propertiesAdd: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTY_ADD,
        body: payload,
        method: "POST",
      }),
    }),

    //Properties view
    propertiesView: builder.query({
      query: (id) => ({
        url: URL.PROPERTY_VIEW + "/" + id,
        method: "GET",
      }),
    }),

    //Property Edit
    propertiesEdit: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.PROPERTY_EDIT + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    //Property Details
    propertyDetailsAdd: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTY_DETAILS_ADD,
        body: payload,
        method: "POST",
      }),
    }),
    //Property Room Details Add
    propertyRoomDetailsAdd: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTY_ROOM_DETAILS_ADD,
        body: payload,
        method: "POST",
      }),
    }),

    //Contents list
    propertyContentList: builder.query({
      query: () => ({
        url: URL.PROPERTY_CONTENT_LIST,
      }),
    }),

    //Total Location
    totalLocationsList: builder.mutation({
      query: (payload) => ({
        url: URL.TOTAL_LOACATIONS,
        body: payload,
        method: "POST",
      }),
    }),

    //Total city list
    totalLocationsList: builder.query({
      query: () => ({
        url: URL.TOTAL_CITY_LIST,
      }),
    }),

    // location List
    locationLists: builder.query({
      query: () => URL.LOCATIONLISTS,
    }),

    // location List
    dropDownLocationList: builder.mutation({
      query: (payload) => ({
        url: URL.DROPDOWN_LOCATIONS,
        body: payload,
        method: "POST",
      }),
    }),

    // location List
    dropDownLocationList: builder.mutation({
      query: (payload) => ({
        url: URL.DROPDOWN_LOCATIONS,
        body: payload,
        method: "POST",
      }),
    }),
    // location List
    locationList: builder.mutation({
      query: (payload) => ({
        url: URL.LOCATIONLIST,
        body: payload,
        method: "POST",
      }),
    }),
    // location List Add
    locationListAdd: builder.mutation({
      query: (payload) => ({
        url: URL.AREAADD,
        body: payload,
        method: "POST",
      }),
    }),
    // country List
    countryList: builder.query({
      query: () => URL.COUNTRYLIST,
    }),
    // state List
    stateList: builder.query({
      query: (id) => URL.STATESLIST + id,
    }),
    // city List
    cityList: builder.query({
      query: (id) => URL.CITYLIST + id,
    }),
    // area List
    areaList: builder.query({
      query: (id) => URL.AREALIST + id,
    }),
    // city View
    cityListView: builder.query({
      query: (id) => URL.CITYVIEW + id + "/show",
    }),
    // area View
    areaListView: builder.query({
      query: (id) => URL.AREAVIEW + id + "/show",
    }),
    // // state List Add
    // stateList: builder.mutation({
    //   query: ({ payload, id }) => ({
    //     url: URL.STATELIST + id,
    //     body: payload,
    //     method: "POST",
    //   }),
    // }),
    // country Add
    countryAdd: builder.mutation({
      query: (payload) => ({
        url: URL.COUNTRYADD,
        body: payload,
        method: "POST",
      }),
    }),
    // state Add
    stateAdd: builder.mutation({
      query: (payload) => ({
        url: URL.STATEADD,
        body: payload,
        method: "POST",
      }),
    }),
    // city Add
    cityAdd: builder.mutation({
      query: (payload) => ({
        url: URL.CITYADD,
        body: payload,
        method: "POST",
      }),
    }),
    // city Edit
    locationsEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.LOCATIONSEDIT + id + "/update",
        body: payload,
        method: "POST",
      }),
    }),
    // area Edit
    areaEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.AREAEDIT + id + "/update",
        body: payload,
        method: "POST",
      }),
    }),
    // area Add
    areaAdd: builder.mutation({
      query: (payload) => ({
        url: URL.AREAADD,
        body: payload,
        method: "POST",
      }),
    }),
    //Properties List
    propertiesList: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTIES_LIST,
        body: payload,
        method: "POST",
      }),
    }),
    //Properties status
    propertiesStatus: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTIES_STATUS,
        body: payload,
        method: "POST",
      }),
    }),

    //Properties Blocked Dates
    propertiesBlockedDates: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTIES_BLOCKED_DATE,
        body: payload,
        method: "POST",
      }),
    }),

    //Properties Block
    propertiesBlock: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTIES_BLOCK,
        body: payload,
        method: "POST",
      }),
    }),

    //PROPERTIES ROOM AVAILABLE
    propertiesRoomAvailable: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTIES_ROOM_AVAILABLE,
        body: payload,
        method: "POST",
      }),
    }),

    //PROPERTIES ROOM BLOCK
    propertiesRoomBlock: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTIES_ROOM_BLOCK,
        body: payload,
        method: "POST",
      }),
    }),

    //Properties room view
    propertiesRoomView: builder.query({
      query: (id) => ({
        url: URL.PROPERTIES_ROOM_VIEW + "/" + id + "/show",
      }),
    }),

    //Default Banner List
    defaultBannerList: builder.query({
      query: () => URL.DEFAULT_BANNER_LIST,
    }),

    //Default Banner Edit
    defaultBannerEdit: builder.mutation({
      query: (payload) => ({
        url: URL.DEFAULT_BANNER_EDIT,
        body: payload,
        method: "POST",
      }),
    }),
    //Default Banner View
    defaultBannerView: builder.query({
      query: () => URL.DEFAULT_BANNER_VIEW,
    }),

    //ROLES LIST
    rolesList: builder.mutation({
      query: (payload) => ({
        url: URL.ROLESLIST,
        body: payload,
        method: "POST",
      }),
    }),
    //ROLES DELETE
    rolesListDelete: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.ROLESDELETE + id,
        body: payload,
        method: "POST",
      }),
    }),

    //ROLES ADD
    rolesListAdd: builder.mutation({
      query: (payload) => ({
        url: URL.ROLESADD,
        body: payload,
        method: "POST",
      }),
    }),
    //ROLES EDIT
    rolesListEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.ROLESEDIT + id + "/update",
        body: payload,
        method: "POST",
      }),
    }),
    //ROLES View
    rolesListView: builder.query({
      query: (id) => URL.ROLESVIEW + id,
    }),
    //ROLES Permission
    rolesPermissions: builder.query({
      query: () => URL.ROLESPERMISSION,
    }),

    //Property Verification
    PropertyVerification: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTY_REQUEST,
        body: payload,
        method: "POST",
      }),
    }),

    //Property document add
    propertyDocumentAdd: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTY_DOCUMENT_ADD,
        body: payload,
        method: "POST",
      }),
    }),

    //Property mmc payment
    propertyMmcPayment: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTY_MMC_PAYMENT,
        body: payload,
        method: "POST",
      }),
    }),

    //Property mmc response
    propertyMmcResponse: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTY_MMC_RESPONSE,
        body: payload,
        method: "POST",
      }),
    }),

    // Property document Verification
    documentRequest: builder.query({
      query: (id) => URL.PROPERTY_DOCUMENT_REQUEST + id + "/show",
    }),
    //Properties Request Approve
    propertiesRequestApprove: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.PROPERTY_REQUEST_APPROVE + "/" + id + "/approval-status",
        body: payload,
        method: "POST",
      }),
    }),
    //Properties image delete
    propertyImageDelete: builder.query({
      query: (id) => ({
        url: URL.PROPERTY_IMAGE_DELETE + "/" + id + "/delete",
      }),
    }),
    //Property Document Update
    propertyDocumentUpdate: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTY_DOCUMENT_UPDATE,
        body: payload,
        method: "POST",
      }),
    }),
    //Property reception list
    propertyReceptionList: builder.query({
      query: (id) => ({
        url: URL.PROPERTY_RECEPTION_LIST + id + "/receptionist",
        method: "GET",
      }),
    }),
    //subscription list
    subscriptionList: builder.mutation({
      query: (payload) => ({
        url: URL.SUBSCRIPTION,
        body: payload,
        method: "POST",
      }),
    }),
    //subscription suspend list
    subscriptionSuspendList: builder.mutation({
      query: (payload) => ({
        url: URL.SUBSCRIPTION_SUSPEND,
        body: payload,
        method: "POST",
      }),
    }),

    //subscription request list
    subscriptionRequestList: builder.mutation({
      query: (payload) => ({
        url: URL.SUBSCRIPTION_REQUEST,
        body: payload,
        method: "POST",
      }),
    }),
    //subscription approved list
    subscriptionApprovedList: builder.mutation({
      query: (payload) => ({
        url: URL.SUBSCRIPTION_APPROVED,
        body: payload,
        method: "POST",
      }),
    }),
    //subscription REject list
    subscriptionRejectList: builder.mutation({
      query: (payload) => ({
        url: URL.SUBSCRIPTION_REJECT,
        body: payload,
        method: "POST",
      }),
    }),
    //subscription approve
    subscriptionRequestApprove: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.SUBSCRIPTION_APPROVAL + id + "/cancel/approve",
        body: payload,
        method: "POST",
      }),
    }),
    //subscription REject
    subscriptionRequestRejection: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.SUBSCRIPTION_REJECTION + id + "/cancel/reject",
        body: payload,
        method: "POST",
      }),
    }),
    //Properties  list
    propertiesListDrop: builder.query({
      query: () => ({
        url: URL.PROPERTIES_LIST_DROP,
      }),
    }),

    //Property block list
    propertyBlockList: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTY_BLOCK_LIST,
        body: payload,
        method: "POST",
      }),
    }),
    //Room block list
    roomBlockList: builder.mutation({
      query: (payload) => ({
        url: URL.ROOM_BLOCK_LIST,
        body: payload,
        method: "POST",
      }),
    }),
    //Properties drop list
    propertiesBlockedDrop: builder.query({
      query: () => ({
        url: URL.PROPERTIES_DROP_LIST,
      }),
    }),
    //property bloked dates list
    propertyBlockDateList: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTY_BLOCKED_DATES,
        body: payload,
        method: "POST",
      }),
    }),
    //property Unbloked dates list
    propertyUnblock: builder.mutation({
      query: (payload) => ({
        url: URL.UNBLOCK_PROPERTY,
        body: payload,
        method: "POST",
      }),
    }),
    //property Unbloked room list
    roomUnblock: builder.mutation({
      query: (payload) => ({
        url: URL.UNBLOCK_ROOM,
        body: payload,
        method: "POST",
      }),
    }),
    //booking upcoming list
    bookingUpcoming: builder.mutation({
      query: (payload) => ({
        url: URL.BOOKINGS_UPCOMING,
        body: payload,
        method: "POST",
      }),
    }),
    //booking completed list
    bookingCompleted: builder.mutation({
      query: (payload) => ({
        url: URL.BOOKINGS_COMPLETED,
        body: payload,
        method: "POST",
      }),
    }),
    //booking cancelled list
    bookingCancelled: builder.mutation({
      query: (payload) => ({
        url: URL.BOOKINGS_CANCELLED,
        body: payload,
        method: "POST",
      }),
    }),
    //user review list
    reviewList: builder.mutation({
      query: (payload) => ({
        url: URL.REVIEWS_LIST,
        body: payload,
        method: "POST",
      }),
    }),

    //user review status
    reviewListStatus: builder.mutation({
      query: (payload) => ({
        url: URL.REVIEWS_STATUS,
        body: payload,
        method: "POST",
      }),
    }),

    //user review status
    reviewListView: builder.query({
      query: (id) => ({
        url: URL.REVIEWS_LIST_VIEW + id,
      }),
    }),

    //user review list Check
    reviewListCheck: builder.mutation({
      query: (payload) => ({
        url: URL.REVIEWS_LIST_CHECK,
        body: payload,
        method: "POST",
      }),
    }),

    //user review delete
    reviewListDelete: builder.query({
      query: (id) => ({
        url: URL.REVIEWS_DELETE + id,
      }),
    }),

    //Dashboard Details
    DashboardDetails: builder.mutation({
      query: (payload) => ({
        url: URL.DASHBOARD_DETAILS,
        body: payload,
        method: "POST",
      }),
    }),
    //Dashboard Date Details
    DashboardDateDetails: builder.mutation({
      query: (payload) => ({
        url: URL.DASHBOARD_DATE_DETAILS,
        body: payload,
        method: "POST",
      }),
    }),
    //suspended property list
    suspendedProperty: builder.mutation({
      query: (payload) => ({
        url: URL.SUSPENDED_PROPERTY_LIST,
        body: payload,
        method: "POST",
      }),
    }),

    //suspended view Table list

    suspendedViewTableList: builder.mutation({
      query: (payload) => ({
        url: URL.SUSPENDED_VIEW_TABLE_LIST,
        body: payload,
        method: "POST",
      }),
    }),

    //suspended Description Add

    suspendedDescriptionAdd: builder.mutation({
      query: (payload) => ({
        url: URL.SUSPENDED_DESCRIPTION_ADD,
        body: payload,
        method: "POST",
      }),
    }),

    //unsuspended property list
    unsuspendedProperty: builder.mutation({
      query: (payload) => ({
        url: URL.UNSUSPENDED_PROPERTY_LIST,
        body: payload,
        method: "POST",
      }),
    }),

    //User Booking Details list
    userBookingDetails: builder.mutation({
      query: (payload) => ({
        url: URL.USER_BOOKING_DETAILS,
        body: payload,
        method: "POST",
      }),
    }),
    // PROPERTY REVERIFICATION
    propertyReverificationList: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTY_REVERIFICATION_LIST,
        body: payload,
        method: "POST",
      }),
    }),
    // PROPERTY REVERIFICATION Approve
    propertyReverificationUpdates: builder.mutation({
      query: (payload) => ({
        url: URL.REVERIFICATION_APPROVE_REJECT,
        body: payload,
        method: "POST",
      }),
    }),

    // PROPERTY REVERIFICATION View
    propertyReverificationView: builder.query({
      query: (id) => ({
        url: URL.REVERIFICATION_PROPERTY_VIEW + id,
      }),
    }),

    //PROPERTY FOLLOWUP
    propertyFollowupList: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTY_FOLLOWUP,
        body: payload,
        method: "POST",
      }),
    }),

    // Notification list
    propertyNotification: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTY_NOTIFICATION,
        body: payload,
        method: "POST",
      }),
    }),
    // Notification list
    suspendedNotification: builder.mutation({
      query: (payload) => ({
        url: URL.SUSPENDED_NOTIFICATION,
        body: payload,
        method: "POST",
      }),
    }),
    // Notification list
    mmcNotification: builder.mutation({
      query: (payload) => ({
        url: URL.MMC_NOTIFICATION,
        body: payload,
        method: "POST",
      }),
    }),
    // Notification list
    otherNotification: builder.mutation({
      query: (payload) => ({
        url: URL.OTHERS_NOTIFICATION,
        body: payload,
        method: "POST",
      }),
    }),

    // Notification Reply
    notificationReply: builder.mutation({
      query: (payload) => ({
        url: URL.NOTIFICATION_REPLY,
        body: payload,
        method: "POST",
      }),
    }),

    // PROPERTY REVERIFICATION View
    salesList: builder.query({
      query: (params) => ({
        url: URL.SALES_LIST + params,
      }),
    }),

    // PROPERTY REVERIFICATION View
    // salesListView: builder.query({
    //   query: (id, payload) => ({
    //     url: `${URL.SALES_VIEW + id}?page=${payload}`,
    //   }),
    // }),
    salesListView: builder.query({
      query: ({ id, pageno }) => ({
        url: `${URL.SALES_VIEW}${id}?page=${pageno}`,
      }),
    }),

    // Notification Reply
    adminSuspendedList: builder.mutation({
      query: (payload) => ({
        url: URL.ADMIN_SUSPENDED_LIST,
        body: payload,
        method: "POST",
      }),
    }),

    //Chat count
    propertyChatCount: builder.query({
      query: (payload) => ({
        url: URL.CHAT_OVERALL_COUNT + payload,
        method: "GET",
      }),
    }),

    //Chat detail count
    propertyChatDetailCount: builder.query({
      query: (payload) => ({
        url: URL.CHAT_OVERALL_COUNT + payload,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLazyLogoutQuery,
  useAdminListMutation,
  useLazyAdminListStatusQuery,
  useLazyAdminListViewQuery,
  useAdminDeleteMutation,
  useAdminEditMutation,
  useLazyAdminListRoleQuery,
  useAdminAddMutation,
  useMinimumAgeMutation,
  useMinimumAgeEditMutation,
  useMinimumAgeStatusMutation,
  useLazyPropertyContentsQuery,
  useLazyPropertyContentsViewQuery,
  usePropertyContentsUpdateMutation,
  useBannerListMutation,
  useMinimumAgeAddMutation,
  useRoomListMutation,
  useLazyRoomViewQuery,
  useLazyMinimumAgeViewQuery,
  useRoomListStatusMutation,
  useRoomListUpdateMutation,
  useRoomListAddMutation,
  useAmenitiesPostListMutation,
  useLazyAmenitiesListQuery,
  useAmenitiesListAddMutation,
  useAmenitiesListStatusMutation,
  useAmenitiesListUpdateMutation,
  useBannerDeleteMutation,
  useLazyBannerViewQuery,
  useLazyAmenitiesViewQuery,
  useBannerListAddMutation,
  useBannerListEditMutation,
  useBannerLocationViewMutation,
  useUsersListMutation,
  useLazyUsersListViewQuery,
  useUserListEditMutation,
  useLazyOwnersListGetQuery,
  useLazyOwnersListViewQuery,
  useOwnersListEditMutation,
  useOwnersListAddMutation,
  useReceptionListMutation,
  useLazyReceptionListGetQuery,
  useLazyReceptionListViewQuery,
  useReceptionListAddMutation,
  useReceptionListEditMutation,
  useLocationListMutation,
  useDropDownLocationListMutation,
  usePropertiesAddMutation,
  usePropertiesEditMutation,
  usePropertiesListMutation,
  useLazyPropertiesViewQuery,
  useLazyPropertyContentListQuery,
  usePropertyDetailsAddMutation,
  useLazyLocationListsQuery,
  useLocationListAddMutation,
  useLazyCountryListQuery,
  useLazyTotalLocationsListQuery,
  useNewTotalLocationsListMutation,
  useOwnersListMutation,
  // useStateListMutation,
  useCountryAddMutation,
  useStateAddMutation,
  useCityAddMutation,
  useAreaAddMutation,
  useLazyStateListQuery,
  useLazyCityListQuery,
  useLazyAreaListQuery,
  useLazyDefaultBannerListQuery,
  useDefaultBannerEditMutation,
  useLazyDefaultBannerViewQuery,
  useRolesListMutation,
  useLazyOwnersDropListQuery,
  usePropertyRoomDetailsAddMutation,
  useRolesListDeleteMutation,
  useRolesListAddMutation,
  useRolesListEditMutation,
  useLazyRolesListViewQuery,
  usePropertyVerificationMutation,
  useLazyRolesPermissionsQuery,
  usePropertiesStatusMutation,
  usePropertiesBlockedDatesMutation,
  usePropertiesBlockMutation,
  usePropertiesRoomAvailableMutation,
  usePropertiesRoomBlockMutation,
  useLazyPropertiesRoomViewQuery,
  useLazyDocumentRequestQuery,
  usePropertiesRequestApproveMutation,
  useLazyPropertyImageDeleteQuery,
  useLazyCityListViewQuery,
  useLocationsEditMutation,
  usePropertyDocumentUpdateMutation,
  useLazyAreaListViewQuery,
  useAreaEditMutation,
  useLazyPropertyReceptionListQuery,
  useLazyPropertyAmenitiesListQuery,
  useSubscriptionListMutation,
  useSubscriptionApprovedListMutation,
  useSubscriptionRejectListMutation,
  useSubscriptionRequestListMutation,
  useSubscriptionSuspendListMutation,
  useSubscriptionRequestApproveMutation,
  useSubscriptionRequestRejectionMutation,
  useLazyPropertiesListDropQuery,
  useLazyUsersListStatusQuery,
  useLazyOwnerStatusQuery,
  useLazyAmenitiesDropQuery,
  useLazyRoomCategoriesDropQuery,
  usePropertyBlockListMutation,
  useRoomBlockListMutation,
  useLazyPropertiesBlockedDropQuery,
  usePropertyBlockDateListMutation,
  usePropertyUnblockMutation,
  useRoomUnblockMutation,
  useBookingUpcomingMutation,
  useBookingCompletedMutation,
  useBookingCancelledMutation,
  useReviewListMutation,
  useReviewListStatusMutation,
  useLazyReviewListViewQuery,
  useReviewListCheckMutation,
  useLazyReviewListDeleteQuery,
  useDashboardDetailsMutation,
  useDashboardDateDetailsMutation,
  useSuspendedPropertyMutation,
  useUnsuspendedPropertyMutation,
  useUserBookingDetailsMutation,
  usePropertyReverificationListMutation,
  useLazyPropertyReverificationViewQuery,
  usePropertyNotificationMutation,
  useMmcNotificationMutation,
  useSuspendedNotificationMutation,
  useOtherNotificationMutation,
  useNotificationReplyMutation,
  useReceptionStatusMutation,
  usePropertyReverificationUpdatesMutation,
  useLazySalesListQuery,
  useLazySalesListViewQuery,
  useSuspendedViewTableListMutation,
  useSuspendedDescriptionAddMutation,
  usePropertyFollowupListMutation,
  useAdminSuspendedListMutation,
  usePropertyDocumentAddMutation,
  usePropertyMmcPaymentMutation,
  usePropertyMmcResponseMutation,
  useLazyPropertyChatCountQuery,
  useLazyPropertyChatDetailCountQuery,
} = api;
